import { createSlice } from "@reduxjs/toolkit";
import { Toastify } from "../../../../components/Toaster";
import { loadingSideEffects, successSideEffects, updatingSideEffects } from "../..";
import { getOutcomeTrackingState, getRequestTrackingState, MutationTrackingState } from "../../../../services/analytics/tracking";

export interface PasswordPolicy {
  DictionaryPasswordValidation: boolean;
  ProfileDataPasswordValidation: boolean;
  ProfileDataPasswordExactMatch: boolean;
  CommonPasswordPreventionValidation: boolean;
  MaxPasswordHistory: number;
  ExpirationFrequency: number;
  ExpirationFrequencyType: string;
  PasswordValidationRules: string;
  IsPasswordHistoryEnabled: boolean;
}

export interface PasswordPolicyState {
  Data: PasswordPolicy;
  isLoading: boolean;
  isUpdating: boolean;
  isSuccess: boolean;
  isError: boolean;
  errorMessage: string | null;
}

export const PasswordPolicySlice = createSlice({
  name: "passwordPolicy",
  initialState: {
    Data: {},
    isLoading: false,
    isUpdating: false,
    isSuccess: false,
    isError: false,
    errorMessage: null
  },
  reducers: {
    getPasswordPolicy(state, _) {
      Object.assign(state, loadingSideEffects);
    },
    getPasswordPolicySuccess(state, action) {
      state.Data = action.payload;
      Object.assign(state, successSideEffects);
    },
    getPasswordPolicyError(state, action) {
      state.isLoading = false;
      state.isError = action.payload;
    },
    updatePasswordPolicy(state, action) {
      Object.assign(state, updatingSideEffects, getRequestTrackingState(action));
    },
    updatePasswordPolicySuccess(state, action) {
      state.isUpdating = false;
      state.isSuccess = true;
      Object.assign(state, getOutcomeTrackingState(state as MutationTrackingState, "success"));

      state.Data = {
        ...state.Data,
        ...action.payload
      };

      Toastify("success", "Password Policy updated successfully");
    },
    updatePasswordPolicyError(state, action) {
      state.isUpdating = false;
      state.isError = true;
      state.errorMessage = action.payload;
      Object.assign(state, getOutcomeTrackingState(state as MutationTrackingState, "error"));
      Toastify("error", action.payload);
    }
  }
});

export const { getPasswordPolicy, getPasswordPolicySuccess, getPasswordPolicyError, updatePasswordPolicy, updatePasswordPolicySuccess, updatePasswordPolicyError } = PasswordPolicySlice.actions;

export default PasswordPolicySlice.reducer;
